//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src

import { mapState } from 'vuex'
import { Toast } from 'mint-ui'
export default {
  name: 'SessionList',
  data() {
    return {
      list: [],
      online: false
    }
  },
  components: {
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted() {
  //觸發後臺socket事件
    this.getSessions()
    this.online = this.user.online
  },
  methods: {
    goChat (session) {
      this.$router.push({path: '/chat', query: {sessionId: session._id}})
    },
    updateUserOnline () {
      this.$store.httpDispatch({})('updateOnline', {
        online: this.online
      }).catch((err) => {
        return Toast({
          message: '請求失敗',
          duration: 3000
        })
      })
    },
    getSessions () {
      if (this.user.type === 'doctor') {
        this.$store.httpDispatch({})('getSessionsByDoctor')
          .then((res) => {
            console.log(res)
            if (res.data.code === 0) {
              this.list = res.data.data.sessions
            }
          })
      } else if (this.user.type === 'customer') {
        this.$store.httpDispatch({})('getSessionsByCustomer')
          .then((res) => {
            console.log(res)
            if (res.data.code === 0) {
              this.list = res.data.data.sessions
            }
          })
      }
    }
  }
}
